app.controller('CIF2-CTRL',
    ['$scope', '$rootScope', '$uibModal', '$http', '$window', '$q', '$filter',
    function ($scope, $rootScope, $uibModal, $http, $window, $q, $filter) {

        $scope.listBankRDN = ['BCA (Online)', 'MANDIRI (Offline)', 'CIMB (Offline)', 'MAYAPADA (Offline)'];
        $scope.rdnbca = $scope.listBankRDN[0];
        $scope.bankRDN = '';
        $scope.CIFInvestor = {}
        $scope.bankpribadi = '';
        $scope.NPWPLength = '16';

        $scope.disabledNPWPNumber = false;

        $scope.OPBBCA = {
            occupation: '',
            occupationText: '',
            position: '',
            positionText: '',
            business: '',
            businessText: ''
        }

        $scope.OPBOTHER = {
            occupation: '',
            occupationText: '',
            position: '',
            positionText: '',
            business: '',
            businessText: ''
        }

        $scope.OPSPOUSE = {
            occupation: '',
            occupationText: '',
            position: '',
            business: '',
        }
        $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerIDCardExpiredDate = new Date(9998, 11, 31);
        $scope.chkSeumurHidup = true;

        $scope.disableBank = false;
        $scope.disableCIFInvestorQuestionRDN = false;
        $scope.MandatoryPermata = false;
        $scope.selectedFundSource = [];
        $scope.selectedSpouseFundSource = [];
        $scope.selectedFundSourceBO = [];

        $scope.ListBank = {};
        $scope.listpekerjaan_BCA = {};
        $scope.listjabatan_BCA = {};
        $scope.listusaha_BCA = {};
        $scope.ListLookup = [];
        $scope.ListOccupation = [];
        $scope.ListSpouseIncome = [];
        $scope.listjabatan_PERMATA = {};
        $scope.IDCardCitySelectedBO = '';
        $scope.CompanyCityBOSelected = '';
        $scope.ListKecamatanBO = [];
        $scope.ListKelurahanBO = [];
        $scope.CompanyCitySelected = '';
        $scope.ListKecamatanCompany = [];
        $scope.ListKelurahanCompany = [];
        $scope.ListOccupationBO = [];


        $scope.SpouseCompanyCitySelected = '';

        $scope.mustSelect = function (event, field) {
            if (event.keyCode == 27) {
                let returnValue = true;
                switch (field) {
                    case 'IDCard': $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCity = ''; returnValue = false;
                        break;
                    case 'CompanyCity': $scope.CIFInvestor.CompanyCity = ''; returnValue = false;
                        break;
                    case 'SpouseCompanyCity': $scope.CIFInvestor.SpouseCompanyCity = ''; returnValue = false;
                        break;
                    case 'CompanyBO': $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCompanyCity = ''; returnValue = false;
                        break;
                    default:
                        break;
                }
                return returnValue;
            }
            return true;
        }

        $scope.selectCity = function (item, model, label, event) {
            if (item.CIFProvinceCityNID) {
                $scope.CIFInvestor.SpouseCompanyCity = item.CIFProvinceCityNID;
            }
        };


        $scope.selectIDCardCityBO = function (item, model, label, event) {
            $scope.ListKecamatanBO = '';
            $scope.ListKelurahanBO = '';

            if (item.CIFProvinceCityNID) {
                $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCity = item.CIFProvinceCityNID;

                $http({
                    method: 'GET',
                    url: '/service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + item.CIFProvinceCityNID,
                    cache: true,
                }).then(function (data) {
                    $scope.ListKecamatanBO = data.data.d;
                    $scope.kecamatanChangeBO();
                }, function (error) { });

            }

        };

        $scope.selectCompanyCity = function (item, model, label, event) {
            $scope.ListKecamatanCompany = '';
            $scope.ListKelurahanCompany = '';

            if (item.CIFProvinceCityNID) {
                $scope.CIFInvestor.CompanyCity = item.CIFProvinceCityNID;

                $http({
                    method: 'GET',
                    url: '/service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + item.CIFProvinceCityNID,
                    cache: true,
                }).then(function (data) {
                    $scope.ListKecamatanCompany = data.data.d;
                    $scope.kecamatanChangeCompanyCity();
                }, function (error) { });

            }

        };

        $scope.kecamatanChangeBO = function () {
            if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerKecamatan) {
                $scope.ListKelurahanBO = $filter('filter')($scope.ListKecamatanBO, { Kecamatan: $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerKecamatan }, true);
            }
        }

        $scope.kelurahanChangeBO = function () {
            if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerKelurahan) {
                let temp = $filter('filter')($scope.ListKecamatanBO, { Kelurahan: $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerKelurahan }, true);
                if (temp) {
                    $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerPostalCode = temp[0].PostalCode;
                }
            }
        }


        $scope.selectCompanyCityBO = function (item, model, label, event) {
            $scope.ListKecamatanCompanyBO = '';
            $scope.ListKelurahanCompanyBO = '';

            if (item.CIFProvinceCityNID) {
                $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCompanyCity = item.CIFProvinceCityNID;

                $http({
                    method: 'GET',
                    url: '/service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + item.CIFProvinceCityNID,
                    cache: true,
                }).then(function (data) {
                    $scope.ListKecamatanCompanyBO = data.data.d;
                    $scope.kecamatanChangeCompanyCityBO();
                }, function (error) { });

            }

        };

        $scope.kecamatanChangeCompanyCityBO = function () {
            if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCompanyAddress2) {
                $scope.ListKelurahanCompanyBO = $filter('filter')($scope.ListKecamatanCompanyBO, { Kecamatan: $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCompanyAddress2 }, true);
            }
        }

        $scope.kelurahanChangeCompanyCityBO = function () {
            if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCompanyAddress3) {
                let temp = $filter('filter')($scope.ListKecamatanCompanyBO, { Kelurahan: $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCompanyAddress3 }, true);
                if (temp) {
                    $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCompanyPostalCode = temp[0].PostalCode;
                }
            }
        }

        $scope.kecamatanChangeCompanyCity = function () {
            if ($scope.CIFInvestor.CompanyKecamatan) {
                $scope.ListKelurahanCompany = $filter('filter')($scope.ListKecamatanCompany, { Kecamatan: $scope.CIFInvestor.CompanyKecamatan }, true);
            }
        }

        $scope.kelurahanChangeCompanyCity = function () {
            if ($scope.CIFInvestor.CompanyKelurahan) {
                let temp = $filter('filter')($scope.ListKecamatanCompany, { Kelurahan: $scope.CIFInvestor.CompanyKelurahan }, true);
                if (temp) {
                    $scope.CIFInvestor.CompanyPostalCode = temp[0].PostalCode;
                }
            }
        }

        $scope.questionRDNchange = function () {

            $scope.OPBBCA.occupation = '';
            $scope.OPBBCA.occupationText = '';
            $scope.OPBBCA.position = '';
            $scope.OPBBCA.positionText = '';
            $scope.OPBBCA.business = '';
            $scope.OPBBCA.businessText = '';


            $scope.OPBOTHER.occupation = '';
            $scope.OPBOTHER.occupationText = '';
            $scope.OPBOTHER.position = '';
            $scope.OPBOTHER.positionText = '';
            $scope.OPBOTHER.business = '';
            $scope.OPBOTHER.businessText = '';

            $scope.CIFInvestor.BankName = "";
            $scope.disableBank = false;


            if ($scope.CIFInvestor.QuestionRDN == '1' || $scope.CIFInvestor.QuestionRDN == 1) {
                $scope.bankpribadi = "BANK CENTRAL ASIA";
                $scope.disableBank = true;
            }
        };

        $scope.changeSpouseMandatory = function (param) {

            if (param)
                $scope.spouseMandatory = true;
            else {
                let flag = false;

                if ($scope.OPBBCA) {
                    if ($scope.OPBBCA.occupation.key == 1 || $scope.OPBBCA.occupation.key == 2) {
                        flag = true;
                        $scope.spouseMandatory2 = true;
                        $scope.spouseMandatory1 = false
                    }
                }

                if ($scope.OPBOTHER) {
                    if ($scope.OPBOTHER.CIFLookupInteger == 4 || $scope.OPBOTHER.CIFLookupInteger == 6) {
                        flag = true;
                        $scope.spouseMandatory2 = true;
                        $scope.spouseMandatory1 = false;
                    }

                }

                if ($scope.selectedFundSource.indexOf(7) > -1) {
                    flag = true;
                    $scope.spouseMandatory2 = true;
                    $scope.spouseMandatory1 = false;
                }

                if ($scope.selectedFundSource.indexOf(6) > -1) {
                    flag = true;
                    $scope.spouseMandatory1 = true;
                    $scope.spouseMandatory2 = false;
                }

                if (!flag) {
                    $scope.CIFInvestor.SpouseCompanyName = '';
                    $scope.CIFInvestor.SpouseIncomePerAnnum = '';
                    $scope.CIFInvestor.SpouseOccupation = '';
                    $scope.CIFInvestor.SpousePosition = '';
                    $scope.CIFInvestor.SpouseNatureOfBusiness = '';
                    $scope.CIFInvestor.SpouseCompanyCity = '';
                    $scope.CIFInvestor.SpouseCompanyPostalCode = '';
                    $scope.CIFInvestor.SpouseCompanyAddress = '';
                    $scope.CIFInvestor.SpouseFundSource = '';

                    $scope.SpouseCompanyCitySelected = '';
                    $scope.selectedSpouseFundSource = [];

                    $scope.OPSPOUSE.occupation = '';
                    $scope.OPSPOUSE.occupationText = '';
                    $scope.OPSPOUSE.position = '';
                    $scope.OPSPOUSE.business = '';
                }

                $scope.spouseMandatory = flag;
            }
        }

        $scope.CopyFromBenef = function () {
            if ($scope.CopyBenef) {
                $scope.CIFInvestor.CIFInvestorBeneficiaryOwner = 1;
                console.log('benef')
            }
            else {
                $scope.CIFInvestor.CIFInvestorBeneficiaryOwner = 2;
                console.log('non benef')
            }

        };

        $scope.NPWPNumber = function () {
            if ($scope.CIFInvestor.QuestionNPWP == 1) {
                $scope.CIFInvestor.NPWPNumber = $scope.CIFInvestor.IDCardNumber
                $scope.disabledNPWPNumber = true;
            }
        };

        $scope.updateNPWP = function () {
            if ($scope.CIFInvestor.NPWPNumber) {
                if (+$scope.QuestionNPWP == 1) {
                    $scope.CIFInvestor.NPWPNumber;
                }
                else {
                    $scope.CIFInvestor.NPWPReason;
                    $scope.CIFInvestor.NPWPNumber = '';
                }
            }
        };



        $scope.occupationChange_BCA = function () {
            if ($scope.OPBBCA.occupation) {

                $scope.OPBBCA.occupationText = '';
                $scope.OPBBCA.position = 0;
                $scope.OPBBCA.positionText = '';
                $scope.OPBBCA.business = 0;
                $scope.OPBBCA.businessText = '';

                if ($scope.OPBBCA.occupation.key == 1 || $scope.OPBBCA.occupation.key == 2)
                    $scope.changeSpouseMandatory(true);
                else
                    $scope.changeSpouseMandatory();

                $http({
                    method: 'GET',
                    url: 'service/client.svc/GetJabatan?Pekerjaan=' + $scope.OPBBCA.occupation.key,
                }).then(function (data) {
                    $scope.listjabatan_BCA = data.data.d;

                    if ($scope.listjabatan_BCA.length) {
                        $scope.OPBBCA.positionText = '';
                        $scope.OPBBCA.position = $scope.listjabatan_BCA[0];

                        $scope.positionChange_BCA();
                    }
                }, function (error) { });
            }
        };

        $scope.occupationChange_PERMATA = function () {
            if ($scope.CIFInvestor.Occupation) {

                $scope.CIFInvestor.OccupationText = '';
                $scope.CIFInvestor.Position = 0;
                $scope.CIFInvestor.PositionText = '';
                $scope.CIFInvestor.NatureOfBusiness = '';
                $scope.CIFInvestor.NatureOfBusinessText = '';

                $http({
                    method: 'GET',
                    url: '/service/client.svc/GetJabatanPERMATA?Pekerjaan=' + $scope.CIFInvestor.Occupation.key,
                }).then(function (data) {
                    $scope.listjabatan_PERMATA = data.data.d;

                    if ($scope.listjabatan_PERMATA.length) {
                        $scope.CIFInvestor.PositionText = '';
                        $scope.CIFInvestor.Position = $scope.listjabatan_PERMATA[0];
                        if ($scope.CIFInvestor.Occupation.key == 3 || $scope.CIFInvestor.Occupation.key == 4 || $scope.CIFInvestor.Occupation.key == 8) {
                            $scope.MandatoryPermata = false;
                            $scope.spouseMandatory = true;
                        } else {
                            $scope.MandatoryPermata = true;
                            $scope.spouseMandatory = false;
                        }

                    }

                }, function (error) { });
            }
        };

        $scope.positionChange_BCA = function () {

            $http({
                method: 'GET',
                url: 'service/client.svc/GetBidangUsaha?Jabatan=' + $scope.OPBBCA.position.key + '&Pekerjaan=' + $scope.OPBBCA.occupation.key,
            }).then(function (data) {
                $scope.listusaha_BCA = data.data.d;

                if ($scope.listusaha_BCA.length) {
                    $scope.OPBBCA.businessText = '';
                    $scope.OPBBCA.business = $scope.listusaha_BCA[0];

                }
            }, function (error) { });
        };


        $scope.occupationChange_OTHER = function () {

            if ($scope.OPBOTHER.occupation) {
                $scope.OPBOTHER.occupationText = '';
                $scope.OPBOTHER.position = '';
                $scope.OPBOTHER.positionText = '';
                $scope.OPBOTHER.business = '';
                $scope.OPBOTHER.businessText = '';

                if ($scope.OPBOTHER.occupation == '4' || $scope.OPBOTHER.occupation == '6')
                    $scope.changeSpouseMandatory(true);
                else
                    $scope.changeSpouseMandatory();
            }
        }

        $scope.toggleFundSourceItem = function (fundsource) {
            let indexCIFLookupInteger = $scope.selectedFundSource.indexOf(fundsource.CIFLookupInteger);

            if (indexCIFLookupInteger > -1)
                $scope.selectedFundSource.splice(indexCIFLookupInteger, 1);
            else
                $scope.selectedFundSource.push(fundsource.CIFLookupInteger);

            if ($scope.selectedFundSource.indexOf(1) < 0)
                $scope.CIFInvestor.FundSourceText = '';

            $scope.changeSpouseMandatory();
        }

        $scope.toggleSpouseFundSourceItem = function (fundsource) {
            $scope.CIFInvestor.SpouseFundSource = '';
            let indexCIFLookupInteger = $scope.selectedSpouseFundSource.indexOf(fundsource.CIFLookupInteger);

            if (indexCIFLookupInteger > -1)
                $scope.selectedSpouseFundSource.splice(indexCIFLookupInteger, 1);
            else
                $scope.selectedSpouseFundSource.push(fundsource.CIFLookupInteger);

            if ($scope.selectedSpouseFundSource.indexOf(1) < 0)
                $scope.CIFInvestor.SpouseFundSourceText = '';
            console.log('fundsource Spouse', $scope.CIFInvestor.SpouseFundSource);
        }

        $scope.toggleFundSourceBOItem = function (fundsource) {

            let indexCIFLookupInteger = $scope.selectedFundSourceBO.indexOf(fundsource.CIFLookupInteger);

            if (indexCIFLookupInteger > -1)
                $scope.selectedFundSourceBO.splice(indexCIFLookupInteger, 1);
            else
                $scope.selectedFundSourceBO.push(fundsource.CIFLookupInteger);

            if ($scope.selectedFundSourceBO.indexOf(1) < 0)
                $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerFundSourceText = '';

            $scope.changeSpouseMandatory();
        }




        $scope.prepareData = function () {
            console.log($scope.CIFInvestor);
            // if ($scope.CIFInvestor.QuestionRDN == '1' || $scope.CIFInvestor.QuestionRDN == 1) {
            //     $scope.CIFInvestor.BankName = $scope.bankpribadi;
            //     $scope.CIFInvestor.Occupation = $scope.OPBBCA.occupation.key;
            //     $scope.CIFInvestor.OccupationText = $scope.OPBBCA.occupationText;
            //     $scope.CIFInvestor.Position = $scope.OPBBCA.position.key;
            //     $scope.CIFInvestor.PositionText = $scope.OPBBCA.positionText;
            //     $scope.CIFInvestor.NatureOfBusiness = $scope.OPBBCA.business.key;
            //     $scope.CIFInvestor.NatureOfBusinessText = $scope.OPBBCA.businessText;
            // }
            // else {
            //     $scope.CIFInvestor.Occupation = Number($scope.OPBOTHER.occupation);
            //     $scope.CIFInvestor.BankName = $scope.bankpribadi;
            //     $scope.CIFInvestor.OccupationText = $scope.OPBOTHER.occupationText;
            //     $scope.CIFInvestor.Position = 0;
            //     $scope.CIFInvestor.NatureOfBusiness = 0;

            //     if ($scope.OPBOTHER.occupation == '4') {

            //         $scope.CIFInvestor.PositionText = '';
            //         $scope.CIFInvestor.NatureOfBusinessText = '';
            //     } else {
            //         $scope.CIFInvestor.PositionText = $scope.OPBOTHER.positionText;
            //         $scope.CIFInvestor.NatureOfBusiness = 0;
            //         $scope.CIFInvestor.NatureOfBusinessText = $scope.OPBOTHER.businessText;
            //     }

            // }
            if ($scope.CopyBenef) {
                $scope.CIFInvestor.CIFInvestorBeneficiaryOwner = 1;
            }
            else {
                $scope.CIFInvestor.CIFInvestorBeneficiaryOwner = 2;
            }
           
            if ($scope.CIFInvestor.QuestionRDN == 6) {
                $scope.CIFInvestor.BankName = $scope.bankpribadi;
                $scope.CIFInvestor.Occupation = $scope.CIFInvestor.Occupation.key;
                if ($scope.CIFInvestor.Occupation == 3) {
                    $scope.CIFInvestor.Position = 0;
                    $scope.CIFInvestor.PositionText = 'Pelajar';
                    $scope.CIFInvestor.NatureOfBusiness = Number($scope.CIFInvestor.NatureOfBusiness)
                    $scope.CIFInvestor.NatureOfBusinessText = 'Pendidikan';
                }
                else if ($scope.CIFInvestor.Occupation == 4) {
                    $scope.CIFInvestor.Position = 0;
                    $scope.CIFInvestor.PositionText = 'Ibu Rumah Tangga';
                    $scope.CIFInvestor.NatureOfBusiness = Number($scope.CIFInvestor.NatureOfBusiness)
                    $scope.CIFInvestor.NatureOfBusinessText = 'Ibu Rumah Tangga';
                }
                else if ($scope.CIFInvestor.Occupation == 8) {
                    $scope.CIFInvestor.Position = 0;
                    $scope.CIFInvestor.PositionText = 'Pensiunan';
                    $scope.CIFInvestor.NatureOfBusiness = Number($scope.CIFInvestor.NatureOfBusiness)
                    $scope.CIFInvestor.NatureOfBusinessText = 'Pensiunan';
                }
                else {
                    $scope.CIFInvestor.Position = $scope.CIFInvestor.Position.key;
                    $scope.CIFInvestor.PositionText = $scope.CIFInvestor.PositionText;
                    $scope.CIFInvestor.NatureOfBusiness = Number($scope.CIFInvestor.NatureOfBusiness);
                    $scope.CIFInvestor.NatureOfBusinessText = $scope.CIFInvestor.NatureOfBusinessText;
                    $scope.CIFInvestor.SpouseCompanyName = '';
                    $scope.CIFInvestor.SpouseIncomePerAnnum = 0;
                    $scope.CIFInvestor.SpouseOccupation = 0;
                    $scope.CIFInvestor.SpousePosition = '';
                    $scope.CIFInvestor.SpouseNatureOfBusiness = '';
                    $scope.CIFInvestor.SpouseCompanyCity = 0;
                    $scope.CIFInvestor.SpouseCompanyPostalCode = '';
                    $scope.CIFInvestor.SpouseCompanyAddress = '';
                    $scope.selectedSpouseFundSource = [];
                    $scope.CIFInvestor.SpouseFundSourceText = '';
                    $scope.CIFInvestor.SpouseOccupationText = '';
                }
            }
            else {
                $scope.CIFInvestor.Occupation = $scope.OPBBCA.occupation.key;
                $scope.CIFInvestor.OccupationText = $scope.OPBBCA.occupationText;
                $scope.CIFInvestor.Position = $scope.OPBBCA.position.key;
                $scope.CIFInvestor.PositionText = $scope.OPBBCA.positionText;
                $scope.CIFInvestor.NatureOfBusiness = $scope.OPBBCA.business.key;
                $scope.CIFInvestor.NatureOfBusinessText = $scope.OPBBCA.businessText;

            }

            if ($scope.spouseMandatory) {
                $scope.CIFInvestor.SpouseOccupation = Number($scope.OPSPOUSE.occupation);
                $scope.CIFInvestor.SpouseOccupationText = $scope.SpouseOccupationText;
                $scope.CIFInvestor.SpousePosition = $scope.OPSPOUSE.position;
                $scope.CIFInvestor.SpouseNatureOfBusiness = ($scope.OPSPOUSE.business);
                //$scope.CIFInvestor.SpouseCompanyCity = Number($scope.SpouseCompanyCitySelected);
            }
            else {
                $scope.CIFInvestor.SpouseIncomePerAnnum = 0;
                $scope.CIFInvestor.SpouseOccupation = 0;
                $scope.CIFInvestor.SpouseCompanyCity = 0;
            }


            if ($scope.selectedFundSource) {
                $scope.CIFInvestor.FundSource = '';
                for (var i = 0; i < $scope.selectedFundSource.length; i++) {
                    if ($scope.CIFInvestor.FundSource.length > 0)
                        $scope.CIFInvestor.FundSource += ',';
                    $scope.CIFInvestor.FundSource += $scope.selectedFundSource[i];

                }
            }

            if ($scope.selectedSpouseFundSource) {
                $scope.CIFInvestor.SpouseFundSource = '';
                for (var i = 0; i < $scope.selectedSpouseFundSource.length; i++) {
                    if ($scope.CIFInvestor.SpouseFundSource.length > 0)
                        $scope.CIFInvestor.SpouseFundSource += ',';
                    $scope.CIFInvestor.SpouseFundSource += $scope.selectedSpouseFundSource[i];

                }
            }

            if ($scope.selectedFundSourceBO) {
                $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerFundSource = '';
                for (var i = 0; i < $scope.selectedFundSourceBO.length; i++) {
                    if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerFundSource.length > 0)
                        $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerFundSource += ',';
                    $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerFundSource += $scope.selectedFundSourceBO[i];

                }
            }

            if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerNationality)
                $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerNationality = Number($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerNationality);

            if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCompanyCity)
                $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCompanyCity = Number($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCompanyCity);

            $scope.CIFInvestor.IsFinished = 0;
            $scope.CIFInvestor.Stage = 2;
        };



        $scope.trim = function () {
            $scope.CIFInvestor.BankCabang = $scope.CIFInvestor.BankCabang ? $scope.CIFInvestor.BankCabang.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.BankCabang;
            $scope.CIFInvestor.BankName = $scope.CIFInvestor.BankName ? $scope.CIFInvestor.BankName.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.BankName;
            $scope.CIFInvestor.BankNumber = $scope.CIFInvestor.BankNumber ? $scope.CIFInvestor.BankNumber.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.BankNumber;
            $scope.CIFInvestor.BankOwner = $scope.CIFInvestor.BankOwner ? $scope.CIFInvestor.BankOwner.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.BankOwner;
            $scope.CIFInvestor.BirthPlace = $scope.CIFInvestor.BirthPlace ? $scope.CIFInvestor.BirthPlace.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.BirthPlace;
            $scope.CIFInvestor.Branch = $scope.CIFInvestor.Branch ? $scope.CIFInvestor.Branch.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.Branch;
            $scope.CIFInvestor.CompanyAddress = $scope.CIFInvestor.CompanyAddress ? $scope.CIFInvestor.CompanyAddress.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.CompanyAddress;
            $scope.CIFInvestor.CompanyName = $scope.CIFInvestor.CompanyName ? $scope.CIFInvestor.CompanyName.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.CompanyName;
            $scope.CIFInvestor.DomicileAddress = $scope.CIFInvestor.DomicileAddress ? $scope.CIFInvestor.DomicileAddress.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.DomicileAddress;
            $scope.CIFInvestor.DomicileKecamatan = $scope.CIFInvestor.DomicileKecamatan ? $scope.CIFInvestor.DomicileKecamatan.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.DomicileKecamatan;
            $scope.CIFInvestor.DomicileKelurahan = $scope.CIFInvestor.DomicileKelurahan ? $scope.CIFInvestor.DomicileKelurahan.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.DomicileKelurahan;
            $scope.CIFInvestor.DomicilePostalCode = $scope.CIFInvestor.DomicilePostalCode ? $scope.CIFInvestor.DomicilePostalCode.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.DomicilePostalCode;
            $scope.CIFInvestor.DomicileRT = $scope.CIFInvestor.DomicileRT ? $scope.CIFInvestor.DomicileRT.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.DomicileRT;
            $scope.CIFInvestor.DomicileRW = $scope.CIFInvestor.DomicileRW ? $scope.CIFInvestor.DomicileRW.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.DomicileRW;
            $scope.CIFInvestor.EducationText = $scope.CIFInvestor.EducationText ? $scope.CIFInvestor.EducationText.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.EducationText;
            $scope.CIFInvestor.Email = $scope.CIFInvestor.Email ? $scope.CIFInvestor.Email.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.Email;
            $scope.CIFInvestor.FATCA1 = $scope.CIFInvestor.FATCA1 ? $scope.CIFInvestor.FATCA1.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.FATCA1;
            $scope.CIFInvestor.FATCA2 = $scope.CIFInvestor.FATCA2 ? $scope.CIFInvestor.FATCA2.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.FATCA2;
            $scope.CIFInvestor.FATCA3 = $scope.CIFInvestor.FATCA3 ? $scope.CIFInvestor.FATCA3.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.FATCA3;
            $scope.CIFInvestor.FirstName = $scope.CIFInvestor.FirstName ? $scope.CIFInvestor.FirstName.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.FirstName;
            $scope.CIFInvestor.FundSource = $scope.CIFInvestor.FundSource ? $scope.CIFInvestor.FundSource.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.FundSource;
            $scope.CIFInvestor.FundSourceText = $scope.CIFInvestor.FundSourceText ? $scope.CIFInvestor.FundSourceText.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.FundSourceText;
            $scope.CIFInvestor.IDCardAddress = $scope.CIFInvestor.IDCardAddress ? $scope.CIFInvestor.IDCardAddress.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.IDCardAddress;
            $scope.CIFInvestor.IDCardKecamatan = $scope.CIFInvestor.IDCardKecamatan ? $scope.CIFInvestor.IDCardKecamatan.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.IDCardKecamatan;
            $scope.CIFInvestor.IDCardKelurahan = $scope.CIFInvestor.IDCardKelurahan ? $scope.CIFInvestor.IDCardKelurahan.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.IDCardKelurahan;
            $scope.CIFInvestor.IDCardNumber = $scope.CIFInvestor.IDCardNumber ? $scope.CIFInvestor.IDCardNumber.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.IDCardNumber;
            $scope.CIFInvestor.IDCardPostalCode = $scope.CIFInvestor.IDCardPostalCode ? $scope.CIFInvestor.IDCardPostalCode.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.IDCardPostalCode;
            $scope.CIFInvestor.IDCardRT = $scope.CIFInvestor.IDCardRT ? $scope.CIFInvestor.IDCardRT.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.IDCardRT;
            $scope.CIFInvestor.IDCardRW = $scope.CIFInvestor.IDCardRW ? $scope.CIFInvestor.IDCardRW.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.IDCardRW;
            $scope.CIFInvestor.MobilePhone = $scope.CIFInvestor.MobilePhone ? $scope.CIFInvestor.MobilePhone.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.MobilePhone;
            $scope.CIFInvestor.MotherName = $scope.CIFInvestor.MotherName ? $scope.CIFInvestor.MotherName.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.MotherName;
            $scope.CIFInvestor.NPWPNumber = $scope.CIFInvestor.NPWPNumber ? $scope.CIFInvestor.NPWPNumber.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.NPWPNumber;
            $scope.CIFInvestor.NPWPReason = $scope.CIFInvestor.NPWPReason ? $scope.CIFInvestor.NPWPReason.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.NPWPReason;
            $scope.CIFInvestor.NatureOfBusinessText = $scope.CIFInvestor.NatureOfBusinessText ? $scope.CIFInvestor.NatureOfBusinessText.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.NatureOfBusinessText;
            $scope.CIFInvestor.Note = $scope.CIFInvestor.Note ? $scope.CIFInvestor.Note.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.Note;
            $scope.CIFInvestor.OccupationText = $scope.CIFInvestor.OccupationText ? $scope.CIFInvestor.OccupationText.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.OccupationText;
            $scope.CIFInvestor.PositionText = $scope.CIFInvestor.PositionText ? $scope.CIFInvestor.PositionText.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.PositionText;
            $scope.CIFInvestor.Question1 = $scope.CIFInvestor.Question1 ? $scope.CIFInvestor.Question1.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.Question1;
            $scope.CIFInvestor.Question1_Text = $scope.CIFInvestor.Question1_Text ? $scope.CIFInvestor.Question1_Text.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.Question1_Text;
            $scope.CIFInvestor.Question2 = $scope.CIFInvestor.Question2 ? $scope.CIFInvestor.Question2.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.Question2;
            $scope.CIFInvestor.Question2_Text = $scope.CIFInvestor.Question2_Text ? $scope.CIFInvestor.Question2_Text.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.Question2_Text;
            $scope.CIFInvestor.Question3 = $scope.CIFInvestor.Question3 ? $scope.CIFInvestor.Question3.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.Question3;
            $scope.CIFInvestor.Question3_Text = $scope.CIFInvestor.Question3_Text ? $scope.CIFInvestor.Question3_Text.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.Question3_Text;
            $scope.CIFInvestor.Question4 = $scope.CIFInvestor.Question4 ? $scope.CIFInvestor.Question4.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.Question4;
            $scope.CIFInvestor.Question4_Text = $scope.CIFInvestor.Question4_Text ? $scope.CIFInvestor.Question4_Text.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.Question4_Text;
            $scope.CIFInvestor.Question5 = $scope.CIFInvestor.Question5 ? $scope.CIFInvestor.Question5.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.Question5;
            $scope.CIFInvestor.Question5_Text = $scope.CIFInvestor.Question5_Text ? $scope.CIFInvestor.Question5_Text.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.Question5_Text;
            $scope.CIFInvestor.Question6 = $scope.CIFInvestor.Question6 ? $scope.CIFInvestor.Question6.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.Question6;
            $scope.CIFInvestor.Question6_Text = $scope.CIFInvestor.Question6_Text ? $scope.CIFInvestor.Question6_Text.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.Question6_Text;
            $scope.CIFInvestor.QuestionFATCA = $scope.CIFInvestor.QuestionFATCA ? $scope.CIFInvestor.QuestionFATCA.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.QuestionFATCA;
            $scope.CIFInvestor.ReferalNumber = $scope.CIFInvestor.ReferalNumber ? $scope.CIFInvestor.ReferalNumber.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.ReferalNumber;
            $scope.CIFInvestor.SpouseCompanyAddress = $scope.CIFInvestor.SpouseCompanyAddress ? $scope.CIFInvestor.SpouseCompanyAddress.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.SpouseCompanyAddress;
            $scope.CIFInvestor.SpouseCompanyName = $scope.CIFInvestor.SpouseCompanyName ? $scope.CIFInvestor.SpouseCompanyName.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.SpouseCompanyName;
            $scope.CIFInvestor.SpouseCompanyPostalCode = $scope.CIFInvestor.SpouseCompanyPostalCode ? $scope.CIFInvestor.SpouseCompanyPostalCode.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.SpouseCompanyPostalCode;
            $scope.CIFInvestor.SpouseFundSource = $scope.CIFInvestor.SpouseFundSource ? $scope.CIFInvestor.SpouseFundSource.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.SpouseFundSource;
            $scope.CIFInvestor.SpouseFundSourceText = $scope.CIFInvestor.SpouseFundSourceText ? $scope.CIFInvestor.SpouseFundSourceText.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.SpouseFundSourceText;
            $scope.CIFInvestor.SpouseName = $scope.CIFInvestor.SpouseName ? $scope.CIFInvestor.SpouseName.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.SpouseName;
            $scope.CIFInvestor.SpouseNatureOfBusiness = $scope.CIFInvestor.SpouseNatureOfBusiness ? $scope.CIFInvestor.SpouseNatureOfBusiness.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.SpouseNatureOfBusiness;
            $scope.CIFInvestor.SpouseOccupationText = $scope.CIFInvestor.SpouseOccupationText ? $scope.CIFInvestor.SpouseOccupationText.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.SpouseOccupationText;
            $scope.CIFInvestor.SpousePosition = $scope.CIFInvestor.SpousePosition ? $scope.CIFInvestor.SpousePosition.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.SpousePosition;
            $scope.CIFInvestor.SpouseRelationship = $scope.CIFInvestor.SpouseRelationship ? $scope.CIFInvestor.SpouseRelationship.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.SpouseRelationship;
            $scope.CIFInvestor.SpouseRelationshipText = $scope.CIFInvestor.SpouseRelationshipText ? $scope.CIFInvestor.SpouseRelationshipText.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.CIFInvestor.SpouseRelationshipText;

        }


        $scope.submit = function () {
            $scope.trim();
            $scope.prepareData();
            var urlsvc = 'service/client.svc/SaveCIF'; // 1
            var preconfirmtranslate = "submitCif2"; // 2
            var postData = { cifdata: $scope.CIFInvestor } // 3
            var method = "POST"; // 4
            $scope.PostGetSwal(preconfirmtranslate, urlsvc, postData, method, function (issuccess) {

                if (issuccess) // 6 
                    $window.location.href = "#/cif/data-pendukung";
            });

        }
        //$scope.submit = function () {

        //    $scope.trim();
        //    $scope.prepareData();
        //    var finished = 0;

        //    $scope.working = true;

        //    $rootScope.AlertYesNo('question', 'Konfirmasi', "Apakah data yang diisi sudah sesuai?")
        //    .then((result) => {
        //        if (result.value) {
        //            $rootScope.AlertShowLoading('warning', 'Loading...', '', 0);
        //            $http({
        //                method: 'POST',
        //                url: 'service/client.svc/SaveCIF',
        //                data:
        //                    {
        //                        cifdata: $scope.CIFInvestor
        //                    },
        //            }).then(function (data) {
        //                swal.close();
        //                var response = data.data.d;
        //                if (response.result && data.status == 200)
        //                    $window.location.href = "#/cif/data-pendukung";
        //                else
        //                    swal('Error', response.message, 'error');
        //            }, function (error) {
        //                swal('Error', 'error - Please check your connection', 'error');
        //            });
        //        }
        //    });

        //}



        var allPromise = $q.all([
            $http({
                method: 'GET',
                url: 'service/client.svc/GetCIFProvinceCity',
                cache: true,
            }).then(function (data) {
                $scope.ListProvinceCity = data.data.d;
            }, function (error) { }),

            $http({
                method: 'GET',
                url: 'service/client.svc/GetCIFLookup',
                cache: true,
            }).then(function (data) {
                $scope.ListLookup = data.data.d;
                if ($scope.ListLookup) {
                    $scope.ListOccupation = $filter('filter')($scope.ListLookup, { CIFLookupID: 'Occupation' }, true);
                    $scope.ListSpouseIncome = $filter('filter')($scope.ListLookup, { CIFLookupID: 'IncomePerAnnum' }, true);
                    $scope.ListFundSource = $filter('filter')($scope.ListLookup, { CIFLookupID: 'FundSource' }, true);
                    $scope.ListIncomePerAnnum = $filter('filter')($scope.ListLookup, { CIFLookupID: 'IncomePerAnnum' }, true);
                    $scope.ListOccupationBO = $filter('filter')($scope.ListLookup, { CIFLookupID: 'Occupation' }, true);
                    $scope.ListFundSourceBO = $filter('filter')($scope.ListLookup, { CIFLookupID: 'FundSource' }, true);
                    $scope.ListIncomePerAnnumBO = $filter('filter')($scope.ListLookup, { CIFLookupID: 'IncomePerAnnum' }, true);
                    $scope.ListInvestmentObjectives = $filter('filter')($scope.ListLookup, { CIFLookupID: 'InvestmentObjectives' }, true);

                }
            }, function (error) { }),

            $http({
                method: 'GET',
                url: 'service/client.svc/GetCIFBank',
                cache: true,
            }).then(function (data) {
                $scope.ListBank = data.data.d;
            }, function (error) { }),

            $http({
                method: 'GET',
                url: 'service/client.svc/GetCIFPekerjaan',
                cache: true,
            }).then(function (data) {
                $scope.listpekerjaan_BCA = data.data.d;
            }, function (error) { }),

              $http({
                  method: 'GET',
                  url: 'service/client.svc/GetCIFPekerjaanPERMATA',
                  cache: true,
              }).then(function (data) {
                  $scope.listpekerjaan_PERMATA = data.data.d;
              }, function (error) { }),

              $http({
                  method: 'GET',
                  url: 'service/client.svc/GetJabatanPERMATA',
                  cache: true,
              }).then(function (data) {
                  $scope.listposition_PERMATA = data.data.d;
              }, function (error) { }),

             $http({
                 method: 'GET',
                 url: 'service/client.svc/GetBidangUsahaPERMATA',
                 cache: true,
             }).then(function (data) {
                 $scope.listnature_PERMATA = data.data.d;
             }, function (error) { }),

            $http({
                method: 'GET',
                url: 'service/client.svc/GetJabatan',
                cache: true,
            }).then(function (data) {
                $scope.listposition_BCA = data.data.d;
            }, function (error) { }),

            $http({
                method: 'GET',
                url: 'service/client.svc/GetBidangUsaha',
                cache: true,
            }).then(function (data) {
                $scope.listnature_BCA = data.data.d;
            }, function (error) { }),
        ]);

        allPromise.then(function () {
            $http({
                method: 'GET',
                url: 'service/client.svc/getCIF',
            }).then(function (data) {
                if (data.data.d != null) {
                    var obj = data.data.d;
                    $scope.CIFInvestor = data.data.d;
                    $scope.CIFInvestor.Stage = 2;
                    if ($scope.CIFInvestor.QuestionRDN == 0) {
                        $scope.CIFInvestor.QuestionRDN = '';
                        console.log('dasdsad');
                    }

                    if ($scope.CIFInvestor.BankOwner == '' || !$scope.CIFInvestor.BankOwner)
                        $scope.CIFInvestor.BankOwner = $scope.CIFInvestor.FirstName;

                    $scope.bankpribadi = $scope.CIFInvestor.BankName;

                    if (data.data.d.CompanyCity) {
                        $scope.CompanyCitySelected = $filter('filter')($scope.ListProvinceCity, { CIFProvinceCityNID: data.data.d.CompanyCity }, true)[0];
                        $http({
                            method: 'GET',
                            url: '/service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + data.data.d.CompanyCity,
                            cache: true,
                        }).then(function (dataKecamatanCompany) {
                            $scope.ListKecamatanCompany = dataKecamatanCompany.data.d;
                            if ($scope.ListKecamatanCompany)
                                $scope.ListKelurahanCompany = $filter('filter')($scope.ListKecamatanCompany, { Kecamatan: $scope.CIFInvestor.CompanyKecamatan }, true);

                        }, function (error) { });
                    }

                    if ($scope.CIFInvestor.SpouseCompanyCity)
                        $scope.SpouseCompanyCitySelected = $filter('filter')($scope.ListProvinceCity, { CIFProvinceCityNID: $scope.CIFInvestor.DomicileCity }, true)[0];

                    if ($scope.CIFInvestor.QuestionRDN) {
                        if ($scope.CIFInvestor.QuestionRDN == 6) {
                            if ($scope.CIFInvestor.Occupation > 0) {
                                $scope.CIFInvestor.Occupation = $filter('filter')($scope.listpekerjaan_PERMATA, { key: $scope.CIFInvestor.Occupation }, true)[0];
                                $http({
                                    method: 'GET',
                                    url: '/service/client.svc/GetJabatanPERMATA?Pekerjaan=' + $scope.CIFInvestor.Occupation.key,
                                }).then(function (data) {
                                    if ($scope.CIFInvestor.Occupation.key == 3 || $scope.CIFInvestor.Occupation.key == 4) {
                                        $scope.MandatoryPermata = false;
                                        $scope.spouseMandatory = true;
                                    }
                                    else {
                                        $scope.listjabatan_PERMATA = data.data.d;
                                        if ($scope.listjabatan_PERMATA.length) {
                                            $scope.CIFInvestor.Position = $filter('filter')($scope.listjabatan_PERMATA, { key: $scope.CIFInvestor.Position }, true)[0];
                                        }
                                        $scope.MandatoryPermata = true;
                                        $scope.spouseMandatory = false;
                                    }

                                }, function (error) { });

                                $scope.OPSPOUSE.occupation = $scope.CIFInvestor.SpouseOccupation;
                                $scope.OPSPOUSE.position = $scope.CIFInvestor.SpousePosition;
                                $scope.OPSPOUSE.business = $scope.CIFInvestor.SpouseNatureOfBusiness;
                                $scope.OPSPOUSE.occupationText = $scope.CIFInvestor.SpouseOccupationText;
                            }
                        }
                        else {

                            $scope.OPBBCA.occupationText = $scope.CIFInvestor.OccupationText;
                            $scope.OPBBCA.positionText = $scope.CIFInvestor.PositionText;
                            $scope.OPBBCA.businessText = $scope.CIFInvestor.NatureOfBusinessText;

                            if ($scope.CIFInvestor.Occupation && $scope.CIFInvestor.Occupation > 0) {
                                $scope.OPBBCA.occupation = $filter('filter')($scope.listpekerjaan_BCA, { key: $scope.CIFInvestor.Occupation }, true)[0];

                                $http({
                                    method: 'GET',
                                    url: 'service/client.svc/GetJabatan?Pekerjaan=' + $scope.OPBBCA.occupation.key,
                                }).then(function (data) {
                                    $scope.listjabatan_BCA = data.data.d;

                                    if ($scope.listjabatan_BCA.length) {
                                        if ($scope.CIFInvestor.Position && $scope.CIFInvestor.Position > 0) {
                                            $scope.OPBBCA.position = $filter('filter')($scope.listjabatan_BCA, { key: $scope.CIFInvestor.Position }, true)[0];
                                            $http({
                                                method: 'GET',
                                                url: 'service/client.svc/GetBidangUsaha?Jabatan=' + $scope.OPBBCA.position.key + '&Pekerjaan=' + $scope.OPBBCA.occupation.key,
                                            }).then(function (data) {
                                                $scope.listusaha_BCA = data.data.d;
                                                if ($scope.listusaha_BCA.length) {
                                                    if ($scope.CIFInvestor.NatureOfBusiness && $scope.CIFInvestor.NatureOfBusiness > 0)
                                                        $scope.OPBBCA.business = $filter('filter')($scope.listusaha_BCA, { key: $scope.CIFInvestor.NatureOfBusiness }, true)[0];
                                                }
                                            }, function (error) { });
                                        }

                                    }
                                }, function (error) { });
                            }
                        }
                    }

                    if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwner == 1) {
                        $scope.CopyBenef = true;
                    }
                    else {
                        $scope.CopyBenef = false;
                    }

                    if ($scope.CIFInvestor.SpouseCompanyCity == 0)
                        $scope.CIFInvestor.SpouseCompanyCity = '';

                    if ($scope.CIFInvestor.FundSource) {
                        $scope.selectedFundSource = [];
                        let temp = $scope.CIFInvestor.FundSource.split(',');
                        for (var i = 0; i < temp.length; i++) {
                            $scope.selectedFundSource.push(Number(temp[i]));
                        }
                    }

                    if ($scope.CIFInvestor.SpouseFundSource) {
                        $scope.selectedSpouseFundSource = [];
                        let temp = $scope.CIFInvestor.SpouseFundSource.split(',');

                        for (var i = 0; i < temp.length; i++) {
                            $scope.selectedSpouseFundSource.push(Number(temp[i]));
                        }
                    }

                    if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerFundSource) {

                        $scope.selectedFundSourceBO = [];
                        let temp = $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerFundSource.split(',');

                        for (var i = 0; i < temp.length; i++) {

                            $scope.selectedFundSourceBO.push(Number(temp[i]));
                        }
                    }

                    if ($scope.CIFInvestor.SpouseOccupation == 0)
                        $scope.CIFInvestor.SpouseOccupation = '';

                    if ($scope.CIFInvestor.SpouseIncomePerAnnum == 0)
                        $scope.CIFInvestor.SpouseIncomePerAnnum = '';

                    if ($scope.CIFInvestor.QuestionNPWP == 0)
                        $scope.CIFInvestor.QuestionNPWP = '';

                    if ($scope.CIFInvestor.IncomePerAnnum == 0)
                        $scope.CIFInvestor.IncomePerAnnum = 0;

                    if ($scope.CIFInvestor.FundSource == null) {
                        $scope.CIFInvestor.FundSource = 0;
                    }


                    if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerFundSource == null) {
                        $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerFundSource = 0;
                    }

                    if (data.data.d.CIFInvestorBeneficiaryOwnerBirthDate)
                        $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerBirthDate = new Date(data.data.d.CIFInvestorBeneficiaryOwnerBirthDate);

                    $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerIDCardExpiredDate = new Date(9998, 11, 31)


                    if (data.data.d.CIFInvestorBeneficiaryOwnerCity) {
                        $scope.IDCardCitySelectedBO = $filter('filter')($scope.ListProvinceCity, { CIFProvinceCityNID: data.data.d.CIFInvestorBeneficiaryOwnerCity }, true)[0];
                        $http({
                            method: 'GET',
                            url: 'service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + data.data.d.CIFInvestorBeneficiaryOwnerCity,
                            cache: true,
                        }).then(function (dataKecamatanBO) {
                            $scope.ListKecamatanBO = dataKecamatanBO.data.d;
                            console.log('data kec', $scope.ListKecamatanBO)
                            console.log('data CIFInvestorBeneficiaryOwnerKecamatan', $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerKecamatan)
                            if ($scope.ListKecamatanBO)
                                $scope.ListKelurahanBO = $filter('filter')($scope.ListKecamatanBO, { Kecamatan: $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerKecamatan }, true);
                            console.log('data kec', $scope.ListKelurahanBO)
                        }, function (error) { });
                    }

                    if (data.data.d.CompanyCity) {
                        $scope.CompanyCitySelected = $filter('filter')($scope.ListProvinceCity, { CIFProvinceCityNID: data.data.d.CompanyCity }, true)[0];
                        $http({
                            method: 'GET',
                            url: '/service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + data.data.d.CompanyCity,
                            cache: true,
                        }).then(function (dataKecamatanCompany) {
                            $scope.ListKecamatanCompany = dataKecamatanCompany.data.d;
                            if ($scope.ListKecamatanCompany)
                                $scope.ListKelurahanCompany = $filter('filter')($scope.ListKecamatanCompany, { Kecamatan: $scope.CIFInvestor.CompanyKecamatan }, true);

                        }, function (error) { });
                    }

                    if (data.data.d.CIFInvestorBeneficiaryOwnerCompanyCity) {
                        $scope.CompanyCityBOSelected = $filter('filter')($scope.ListProvinceCity, { CIFProvinceCityNID: data.data.d.CIFInvestorBeneficiaryOwnerCompanyCity }, true)[0];
                        $http({
                            method: 'GET',
                            url: 'service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + data.data.d.CIFInvestorBeneficiaryOwnerCompanyCity,
                            cache: true,
                        }).then(function (dataKecamatanCompanyBO) {
                            $scope.ListKecamatanCompanyBO = dataKecamatanCompanyBO.data.d;
                            console.log('data kec company', $scope.ListKecamatanCompanyBO)
                            if ($scope.ListKecamatanCompanyBO)
                                $scope.ListKelurahanCompanyBO = $filter('filter')($scope.ListKecamatanCompanyBO, { Kecamatan: $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCompanyAddress2 }, true);
                        }, function (error) { });
                    }


                    if ($scope.CIFInvestor.QuestionRDN == 1) {
                        $scope.changeSpouseMandatory();
                        $scope.OPSPOUSE.occupation = $scope.CIFInvestor.SpouseOccupation;
                        $scope.OPSPOUSE.occupationText = $scope.CIFInvestor.SpouseOccupationText;
                        $scope.OPSPOUSE.position = $scope.CIFInvestor.SpousePosition;
                        $scope.OPSPOUSE.business = $scope.CIFInvestor.SpouseNatureOfBusiness;
                    }

                    console.log("1", $scope.CIFInvestor.IncomePerAnnum);
                } // END IF data.data.d
            }, function (error) { });
        });


        $scope.logOff = function () {
            $http({
                method: 'POST',
                url: 'service/client.svc/logOff',
            }).then(function (data) {
                console.log(data);
                if (data.data.d == true) {
                    $window.location.href = "#/login";
                    $window.location.reload();
                }
            }, function (error) { })
        };

    }]);





app.controller('BCAAgreementCtrl',
    ['$scope', '$uibModalInstance', 'agreementNumber', '$window',
    function ($scope, $uibModalInstance, agreementNumber, $window) {

        $scope.agreementNumber = agreementNumber;
        console.log('open', $scope.agreementNumber);
        $scope.accept = function () {
            $uibModalInstance.close('accept', $scope.agreementNumber);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel', $scope.agreementNumber);
        };
    }]);